import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow licenses.
 */
export class LicenseOperations {
  constructor(private client: BaserowClient) {}
  
  // License methods will be implemented here
} 